<template>
  <div>
    <div class="row">
      <div
        :class="[
          scenarioViewGroup === 'L'
            ? 'col-12'
            : 'col-xs-12 col-sm-6 col-md-4 col-lg-4',
          'scenario-list',
        ]"
      >
        <!-- 시나리오 목록 -->
        <c-table
          ref="table"
          title="LBL0001165"
          :columns="gridColumns"
          :gridHeight="setheight"
          :data="process.scenarios"
          :merge="scenarioViewGroup === 'L' ? grid.merge : []"
          :filtering="false"
          :columnSetting="false"
          :usePaging="false"
          :editable="editable && !disabled"
          :customTrClass="setTrClass"
          selection="multiple"
          rowKey="ramKrasAssessScenarioId"
          @callbackProxy="callbackProxy"
          @innerBtnClicked="innerBtnClicked"
          @table-data-change="tableDataChange"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline>
              <c-update-btn
                name="updateBtn"
                :data="updateBtnData"
                :btnEditable="btnEditable"
                :flagCondition="flagCondition"
                @back="back"
              />
              <!-- 이전평가결과조회 -->
              <c-btn
                v-show="isCompared"
                label="LBL0001166"
                icon="compare_arrows"
                @btnClicked="compareScenario"
              />
              <!-- 삭제 -->
              <c-btn
                v-if="editable && !disabled"
                label="LBLREMOVE"
                icon="remove"
                @btnClicked="removeScenario"
              />
              <!-- 평가완료 -->
              <c-btn
                v-show="editable && !disabled && !btnEditable"
                :isSubmit="isComplete"
                :url="completeUrl"
                :param="process"
                mappingType="PUT"
                label="LBL0001162"
                icon="check"
                @beforeAction="completeProcess"
                @btnCallback="completeProcessCallback"
              />
              <!-- 저장 -->
              <c-btn
                v-show="editable && !disabled && scenarioViewGroup === 'L'"
                :isSubmit="isSave"
                :url="saveUrl"
                :param="process.scenarios"
                mappingType="PUT"
                label="LBLSAVE"
                icon="save"
                @beforeAction="saveScenario"
                @btnCallback="saveScenarioCallback"
              />
            </q-btn-group>
          </template>
          <template v-slot:suffixTitle>
            <q-btn-group outline class="scenario-view-group">
              <q-btn
                :outline="scenarioViewGroup !== 'L'"
                :color="scenarioViewGroup === 'L' ? 'indigo' : 'grey'"
                size="11px"
                label=""
                icon="view_list"
                @click="listView"
              >
                <q-tooltip>
                  <!-- 목록형 -->
                  {{ $label("LBL0001167") }}
                </q-tooltip>
              </q-btn>
              <q-btn
                :outline="scenarioViewGroup !== 'C'"
                :color="scenarioViewGroup === 'C' ? 'indigo' : 'grey'"
                size="11px"
                label=""
                icon="space_dashboard"
                @click="cardView"
              >
                <q-tooltip>
                  <!-- 카드형 -->
                  {{ $label("LBL0001168") }}
                </q-tooltip>
              </q-btn>
            </q-btn-group>
          </template>
          <template v-slot:customArea="{ props, col }">
            <template v-if="col.name === 'customCol'">
              <component
                :is="imprComponent"
                :col="col"
                :props="props"
                :inputEditable="
                  editable &&
                  Boolean(props.row.ramKrasAssessScenarioId) &&
                  !disabled
                "
                :requestContentsCols="requestContentsCols"
                tableKey="ramKrasAssessScenarioId"
                ibmTaskTypeCd="ITT0000020"
                ibmTaskUnderTypeCd="ITTU000025"
                @imprChange="imprChange"
              />
            </template>
            <template v-else-if="col.name === 'item'">
              <q-item class="card-scenario-list">
                <q-item-section>
                  <q-item-label class="scenario-card-title">{{
                    `${props.row["jobName"]} - ${props.row["riskHazardNameClass"]}`
                  }}</q-item-label>
                  <q-item-label class="scenario-card-title" caption lines="2">{{
                    props.row["riskOccurrenceCause"]
                  }}</q-item-label>
                </q-item-section>
                <q-item-section side style="padding-right: 0px">
                  <q-icon
                    class="cursor-pointer"
                    color="primary"
                    size="sm"
                    name="arrow_forward_ios"
                    @click="getDetail(props.row.ramKrasAssessScenarioId)"
                  />
                </q-item-section>
              </q-item>
            </template>
            <template v-else-if="col.name === 'riskHazardPicture'">
              <q-icon
                class="cursor-pointer"
                size="sm"
                color="blue-6"
                name="image"
                @click.stop="openHazardPicture(props)"
              />
            </template>
            <template v-else-if="col.name === 'picture'">
              <q-icon
                class="cursor-pointer"
                size="sm"
                color="green"
                name="image"
                @click.stop="openImprPicture(props)"
              />
            </template>
          </template>
        </c-table>
      </div>
      <div
        v-if="scenarioViewGroup === 'C'"
        class="col-xs-12 col-sm-6 col-md-8 col-lg-8 scenario-card"
      >
        <q-form ref="editForm">
          <div class="row">
            <div class="col-5">
              <!-- 상세정보 -->
              <c-card title="LBL0001169" class="cardClassDetailForm no-margin">
                <template slot="card-button">
                  <q-btn-group outline>
                    <!-- 저장 -->
                    <c-btn
                      v-show="editable && !disabled"
                      :isSubmit="isSaveUnit"
                      :url="saveUnitUrl"
                      :param="scenario"
                      mappingType="PUT"
                      label="LBLSAVE"
                      icon="save"
                      @beforeAction="saveScenarioUnit"
                      @btnCallback="saveScenarioUnitCallback"
                    />
                  </q-btn-group>
                </template>
                <template slot="card-detail">
                  <div class="col-12">
                    <!-- 사진 -->
                    <c-upload-picture
                      height="300px"
                      :attachInfo="attachHazardInfo"
                      :editable="editable && !disabled && selectScenario"
                    >
                    </c-upload-picture>
                  </div>
                  <div class="col-12">
                    <c-text
                      :disabled="true"
                      :editable="editable"
                      label="작업순서 - (평가구분)유해위험요인"
                      name="scenarioTarget"
                      v-model="scenarioTarget"
                    >
                    </c-text>
                  </div>
                  <div class="col-6">
                    <!-- 관련법규 -->
                    <c-text
                      :disabled="disabled || !selectScenario"
                      :editable="editable"
                      label="LBL0001021"
                      name="relationLaw"
                      v-model="scenario.relationLaw"
                    >
                    </c-text>
                  </div>
                  <div class="col-6">
                    <!-- 위험등록부 -->
                    <c-checkbox
                      :disabled="disabled || !selectScenario"
                      :editable="editable"
                      :isFlag="true"
                      label="LBL0001171"
                      name="riskbookFlag"
                      v-model="scenario.riskbookFlag"
                    />
                  </div>
                  <div class="col-12">
                    <!-- 원인 -->
                    <c-text
                      :disabled="disabled || !selectScenario"
                      :editable="editable"
                      label="LBL0001006"
                      name="riskOccurrenceCause"
                      v-model="scenario.riskOccurrenceCause"
                    >
                    </c-text>
                  </div>
                  <div class="col-12">
                    <!-- 결과 -->
                    <c-text
                      :disabled="disabled || !selectScenario"
                      :editable="editable"
                      label="LBL0001007"
                      name="riskOccurrenceResult"
                      v-model="scenario.riskOccurrenceResult"
                    >
                    </c-text>
                  </div>
                  <div class="col-6">
                    <!-- 평가일 -->
                    <c-datepicker
                      :disabled="disabled || !selectScenario"
                      :editable="editable"
                      label="LBL0001013"
                      name="assessDate"
                      v-model="scenario.assessDate"
                    />
                  </div>
                  <div class="col-6">
                    <!-- 평가자 -->
                    <c-field
                      :disabled="disabled || !selectScenario"
                      :editable="editable"
                      :data="scenario"
                      label="LBL0001014"
                      name="assessUserId"
                      v-model="scenario.assessUserId"
                      @username="
                        (val) => {
                          scenario.assessUserName = val;
                        }
                      "
                    />
                  </div>
                </template>
              </c-card>
            </div>
            <div class="col-7">
              <!-- 개선정보 -->
              <c-card title="LBL0001172" class="cardClassDetailForm no-margin">
                <template slot="card-detail">
                  <div class="col-4">
                    <!-- 사진 -->
                    <c-upload-picture
                      isMultiTask
                      :attachInfo="attachBeforeInfo"
                      :editable="editable && !disabled && selectScenario"
                    >
                    </c-upload-picture>
                  </div>
                  <div class="col-5">
                    <!-- 현재안전조치 -->
                    <c-textarea
                      :disabled="disabled || !selectScenario"
                      :editable="editable"
                      :rows="3"
                      label="LBL0001025"
                      name="currentSafetyMeasures"
                      v-model="scenario.currentSafetyMeasures"
                    >
                    </c-textarea>
                  </div>
                  <div class="col-3">
                    <!-- 개선 전 위험도 -->
                    <q-list dense bordered separator>
                      <q-item>
                        <div class="card-risk-info detail-risk">
                          <q-item-section>
                            <!-- 빈도 -->
                            <q-item-label>{{
                              $label("LBL0001009")
                            }}</q-item-label>
                          </q-item-section>

                          <q-item-section side>
                            <q-item-label>{{
                              scenario.beforeFrequency
                            }}</q-item-label>
                          </q-item-section>
                        </div>
                        <q-separator spaced vertical />
                        <div class="card-risk-info detail-risk">
                          <q-item-section>
                            <!-- 강도 -->
                            <q-item-label>{{
                              $label("LBL0001010")
                            }}</q-item-label>
                          </q-item-section>

                          <q-item-section side>
                            <q-item-label>{{
                              scenario.beforeStrength
                            }}</q-item-label>
                          </q-item-section>
                        </div>
                      </q-item>
                      <!-- <q-separator spaced inset /> -->
                      <q-item class="detail-risk">
                        <q-item-section>
                          <!-- 위험도 -->
                          <q-item-label>{{
                            $label("LBL0001011")
                          }}</q-item-label>
                        </q-item-section>

                        <q-item-section side class="detail-risk-num">
                          <q-item-label>{{ scenario.beforeRisk }}</q-item-label>
                        </q-item-section>
                        <q-item-section
                          v-if="!disabled && selectScenario"
                          side
                          class="detail-risk-num"
                        >
                          <q-btn
                            unelevated
                            round
                            dense
                            size="10px"
                            color="primary"
                            icon="create"
                          >
                            <q-popup-proxy ref="beforeRiskProxy">
                              <component
                                :is="riskPopComponent"
                                width="800px"
                                :props="{
                                  row: {
                                    ramMatrixId: scenario.ramMatrixId,
                                  },
                                }"
                                :editable="
                                  editable && !disabled && selectScenario
                                "
                                @callback="
                                  (data, color) =>
                                    callbackCardProxy(
                                      data,
                                      color,
                                      'beforeRiskProxy',
                                    )
                                "
                              />
                            </q-popup-proxy>
                          </q-btn>
                        </q-item-section>
                      </q-item>
                    </q-list>
                  </div>
                  <div class="col-12">
                    <!-- 개선진행여부 -->
                    <c-radio
                      :disabled="disabled || !selectScenario"
                      :editable="editable"
                      :comboItems="improveFlagItems"
                      label="LBL0001173"
                      name="improveFlag"
                      v-model="scenario.improveFlag"
                      @datachange="improveFlagChange"
                    >
                    </c-radio>
                  </div>
                  <div class="col-12">
                    <!-- 개선 목록 -->
                    <c-table
                      title="LBL0001174"
                      :editable="editable && !disabled && selectScenario"
                      :columns="gridImpr.columns"
                      :data="scenario.imprs"
                      :gridHeight="gridImpr.height"
                      @linkClick="
                        (row) =>
                          linkClick(
                            {
                              sopImprovementId: row.sopImprovementId,
                              ramKrasAssessImprId: row.ramKrasAssessImprId,
                            },
                            row,
                          )
                      "
                    >
                      <template slot="table-button">
                        <q-btn-group outline>
                          <!-- 개선요청 -->
                          <c-btn
                            v-if="editable && !disabled && selectScenario"
                            label="LBLIMPRREQUEST"
                            icon="add"
                            @btnClicked="openImprRequest"
                          />
                        </q-btn-group>
                      </template>
                    </c-table>
                  </div>
                  <div class="col-4">
                    <!-- 사진 -->
                    <c-upload-picture
                      isMultiTask
                      :attachInfo="attachAfterInfo"
                      :editable="
                        editable &&
                        !disabled &&
                        selectScenario &&
                        afterRiskEditable
                      "
                    >
                    </c-upload-picture>
                  </div>
                  <div class="col-5">
                    <!-- 추가 리스크관리 계획 -->
                    <c-textarea
                      :disabled="
                        disabled || !selectScenario || !afterRiskEditable
                      "
                      :editable="editable"
                      :rows="3"
                      label="LBL0001122"
                      name="improvementMeasures"
                      v-model="scenario.improvementMeasures"
                    >
                    </c-textarea>
                  </div>
                  <div class="col-3">
                    <!-- 개선 후 위험도 -->
                    <q-list dense bordered separator>
                      <q-item>
                        <div class="card-risk-info detail-risk">
                          <q-item-section>
                            <!-- 빈도 -->
                            <q-item-label>{{
                              $label("LBL0001009")
                            }}</q-item-label>
                          </q-item-section>

                          <q-item-section side>
                            <q-item-label>{{
                              scenario.afterFrequency
                            }}</q-item-label>
                          </q-item-section>
                        </div>
                        <q-separator spaced vertical />
                        <div class="card-risk-info detail-risk">
                          <q-item-section>
                            <!-- 강도 -->
                            <q-item-label>{{
                              $label("LBL0001010")
                            }}</q-item-label>
                          </q-item-section>

                          <q-item-section side>
                            <q-item-label>{{
                              scenario.afterStrength
                            }}</q-item-label>
                          </q-item-section>
                        </div>
                      </q-item>
                      <!-- <q-separator spaced inset /> -->
                      <q-item class="detail-risk">
                        <q-item-section>
                          <!-- 위험도 -->
                          <q-item-label>{{
                            $label("LBL0001011")
                          }}</q-item-label>
                        </q-item-section>

                        <q-item-section side class="detail-risk-num">
                          <q-item-label>{{ scenario.afterRisk }}</q-item-label>
                        </q-item-section>
                        <q-item-section
                          v-if="
                            !disabled && selectScenario && afterRiskEditable
                          "
                          side
                          class="detail-risk-num"
                        >
                          <q-btn
                            unelevated
                            round
                            dense
                            size="10px"
                            color="primary"
                            icon="create"
                          >
                            <q-popup-proxy ref="afterRiskProxy">
                              <component
                                :is="riskPopComponent"
                                width="800px"
                                :props="{
                                  row: {
                                    ramMatrixId: scenario.ramMatrixId,
                                  },
                                }"
                                :editable="
                                  editable && !disabled && selectScenario
                                "
                                @callback="
                                  (data, color) =>
                                    callbackCardProxy(
                                      data,
                                      color,
                                      'afterRiskProxy',
                                    )
                                "
                              />
                            </q-popup-proxy>
                          </q-btn>
                        </q-item-section>
                      </q-item>
                    </q-list>
                  </div>
                </template>
              </c-card>
            </div>
          </div>
        </q-form>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
    <c-win-pop
      ref="winPopup"
      @onClose="(val) => evtCloseWinPopup(val)"
      @onRecvEvtFromWinPop="(val) => onRecvWinPop(val)"
    />
  </div>
</template>

<script>
import { uid } from "quasar";
import selectConfig from "@/js/selectConfig";
import transactionConfig from "@/js/transactionConfig";

export default {
  name: "kras-scenario",

  props: {
    process: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: "", // 평가 일련번호
        processCd: "", // 단위공정 코드
        processName: "", // 단위공정명
        ramProcessAssessStepCd: "", // 평가진행상태
        processExplainFeature: "", // 공정 특징 설명
        assessDeptCd: "", // 평가 부서 코드
        assessUserId: "", // 평가 담당자
        assessUserName: "", // 평가 담당자
        ramMatrixId: "",
        scenarios: [],
        reCheckedCnt: 0,
      }),
    },
    param: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: "",
        ramStepCd: "",
        ramTechniqueCd: "",
        isApprContent: false,
      }),
    },
    assessPlan: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: "", // 평가 일련번호
        plantCd: "", // 사업장 코드
        ramTechniqueCd: null, // 평가기법 코드_HAZOP/4m/JSA/CHECKLIST
        ramAssessTypeCd: null, // 평가구분_최초/정기/수시
        ramAssessTypeCdSave: null, // 평가구분_최초/정기/수시
        assessmentName: "", // 평가명
        assessmentStartDate: "", // 평가시작일
        assessmentEndDate: "", // 평가종료일
        assessmentPeriod: [],
        assessmentYear: "", // 평가년도
        ramStepCd: "", // 평가 진행단계 코드
        deptCd: "", // 평가부서
        assessmentManageDeptCd: "", // 평가주관 부서 코드
        assessmentManageUserId: "", // 평가주관 담당자 ID
        ramMatrixId: null, // 위험메트릭스 번호
        sopMocId: "", // MOC 일련번호
        remark: "", // 상세내용
        workArea: "", // 작업지역
        regUserId: "", // 작성자 ID
        regUserName: "", // 작성자 ID
        regDtStr: "",
        reviewUserId: "", // 검토자 ID
        reviewDate: "", // 검토일
        approvalUserId: "", // 승인자 ID
        approvalDate: "", // 승인일
        vendorCd: "",
        sopConstructionId: "",
        approvalStatusCd: "", // 결재관련 결재상태
        sysApprovalRequestId: "", // 결재관련 결재요청코드
        chgUserId: "", // 수정자 ID
        processes: [], // 대상공정 목록
      }),
    },
    height: {
      type: String,
      default: function () {
        return "";
      },
    },
    planUpdateBtnData: {
      title: "LBLPLAN", // 계획
      flag: false,
      research: "",
      planResearch: "",
    },
  },
  data() {
    return {
      grid: {
        merge: [
          { index: 0, colName: "groupMdmSopId" },
          { index: 1, colName: "groupRiskHazard" },
          { index: 2, colName: "groupRiskHazard" },
        ],
        data: [],
      },
      gridImpr: {
        columns: [
          {
            name: "ibmTitle",
            field: "ibmTitle",
            label: "LBLTITLE",
            align: "left",
            style: "width:250px",
            sortable: true,
            type: "link",
          },
          {
            name: "ibmStepName",
            field: "ibmStepName",
            label: "LBLSTEPPROGRESS",
            align: "center",
            style: "width:85px",
            sortable: true,
          },
          {
            name: "improveRequestDeptName",
            field: "improveRequestDeptName",
            // 요청부서
            label: "LBL0000927",
            align: "center",
            style: "width:85px",
            sortable: true,
          },
          {
            name: "actionDeptName",
            field: "actionDeptName",
            // 조치부서
            label: "LBL0001018",
            align: "center",
            style: "width:85px",
            sortable: true,
          },
        ],
        height: "350px",
      },
      scenario: {
        ramKrasAssessScenarioId: "", // 시나리오 일련번호_시나리오의 한 라인(원일별)
        ramRiskAssessmentPlanId: "", // 평가 일련번호
        processCd: "", // 단위공정 코드
        processName: "", // 단위공정
        mdmSopId: "", // 안전작업 표준 일련번호_sop 작업이 아닌경우는 "tmp_001"과 같이 생성
        jobName: "", // 안전작업 명
        ramRiskHazardClassCd: "", // 유해위험분류 코드
        ramRiskHazardId: "", // 유해위험요인 코드
        riskHazardName: "", // 유해위험요인 명
        riskOccurrenceCause: "", // 위험발생 원인
        riskOccurrenceResult: "", // 위험발생 결과
        relationLaw: "", // 관련법규_유해위험요인 마스터에스 불러와서 편집후 저장
        improveFlag: "X", // 개선여부
        currentSafetyMeasures: "", // 현재 안전조치
        beforeRamMatrixRiskId: "", // 전 위험도 no
        afterRamMatrixRiskId: "", // 후 위험도 no
        improvementMeasures: "", // 개선대책
        assessDate: "", // 평가일
        assessUserId: "", // 평가자 ID
        regUserId: "", // 작성자 ID
        chgUserId: "", // 수정자 ID
        imprs: [], // 개선목록
      },
      riskPopComponent: () => import(`${"@/pages/ram/base/matrixPop.vue"}`),
      updateBtnData: {
        title: "LBL0001164", // 평가
        flag: false,
        research: "",
      },
      improveFlagItems: [
        { code: "X", codeName: "상관없음" },
        { code: "Y", codeName: "개선진행" },
        { code: "N", codeName: "유지" },
      ],
      attachHazardInfo: {
        isSubmit: "",
        taskClassCd: "RISK_HAZARD",
        taskKey: "",
      },
      attachBeforeInfo: {
        isSubmit: "",
        task: [],
        // taskClassCd: 'KRAS_SCENARIO_BEFORE',
        // taskKey: '',
      },
      attachAfterInfo: {
        isSubmit: "",
        task: [],
      },
      imprComponent: () => import(`${"@/pages/common/ibm/tableImpr.vue"}`),
      activeWinProps: {
        processCd: "",
        ramKrasAssessScenarioId: "",
      },
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        width: "80%",
        param: {},
        closeCallback: null,
      },
      scenarioViewGroup: "L",
      rowIndex: 0,
      editable: true,
      isSave: false,
      isSaveUnit: false,
      isComplete: false,
      listUrl: "",
      detailUrl: "",
      listImprUrl: "",
      saveUrl: "",
      saveUnitUrl: "",
      deleteUrl: "",
      completeUrl: "",
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
    window.addEventListener("beforeunload", () => {
      this.$refs.winPopup.closeWinPop();
    });
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.$refs.winPopup.closeWinPop();
    window.removeEventListener("beforeunload", () => {
      this.$refs.winPopup.closeWinPop();
    });
  },
  computed: {
    isCompared() {
      return this.process.reCheckedCnt > 0;
    },
    isManager() {
      return this.$_.indexOf(this.$store.getters.auths, "SAGI000028") > -1;
    },
    disabled() {
      return (
        (!(
          this.param.ramStepCd === "RRS0000005" ||
          this.param.ramStepCd == "RRS0000010"
        ) ||
          this.process.ramProcessAssessStepCd === "RPA0000005") &&
        !this.updateBtnData.flag
      );
    },
    setheight() {
      let pxRemove = this.height.replace("px", "");
      return this.height && this.height.indexOf("px") > -1 && !isNaN(pxRemove)
        ? Number(pxRemove) - 80 + "px"
        : "500px";
    },
    btnEditable() {
      return (
        (this.editable &&
          this.param.ramStepCd === "RRS0000010" &&
          this.process.ramProcessAssessStepCd === "RPA0000005" &&
          (this.param.isApprContent
            ? true
            : this.assessPlan.approvalStatusCd !== "ASC0000001")) ||
        (this.process.ramProcessAssessStepCd === "RPA0000005" && this.isManager)
      );
    },
    flagCondition() {
      return (
        this.param.ramStepCd === "RRS0000010" &&
        (this.param.isApprContent
          ? true
          : this.assessPlan.approvalStatusCd !== "ASC0000001")
      );
    },
    gridColumns() {
      let cols = [];
      if (this.scenarioViewGroup === "L") {
        cols = [
          {
            fix: true,
            name: "jobName",
            field: "jobName",
            label: "작업순서",
            align: "left",
            style: "width:120px",
            sortable: true,
          },
          {
            fix: true,
            name: "riskHazardPicture",
            field: "riskHazardPicture",
            // 사진
            label: "LBL0001175",
            align: "center",
            style: "width:40px",
            sortable: false,
            type: "custom",
          },
          {
            fix: true,
            name: "riskHazardNameClass",
            field: "riskHazardNameClass",
            // 분류-유해위험요인
            label: "LBL0001020",
            align: "left",
            style: "width:250px",
            sortable: false,
            innerBtn: true,
            btns: [
              {
                label: "",
                icon: "add",
                color: "light-blue",
                value: "1",
                tooltip:
                  '가능한 원인 추가 <font color="#F0F4C3"><b>(※ 관리되는 항목)</b></font>',
              },
              {
                label: "",
                icon: "add",
                color: "orange",
                value: "2",
                tooltip: "원인 추가",
              },
            ],
          },
          {
            fix: true,
            name: "relationLaw",
            field: "relationLaw",
            // 관련법규
            label: "LBL0001021",
            align: "left",
            type: "text",
            style: "width:120px",
            sortable: false,
          },
          {
            name: "riskOccurrenceCause",
            field: "riskOccurrenceCause",
            label: "상황/원인",
            align: "left",
            style: "width:200px",
            type: "text",
            sortable: false,
          },
          {
            name: "riskOccurrenceResult",
            field: "riskOccurrenceResult",
            // 결과
            label: "LBL0001007",
            align: "left",
            style: "width:200px",
            type: "text",
            sortable: false,
          },
          {
            name: "currentSafetyMeasures",
            field: "currentSafetyMeasures",
            // 현재안전조치
            label: "LBL0001025",
            align: "left",
            type: "text",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "before",
            field: "before",
            // 개선전
            label: "LBL0001008",
            align: "center",
            child: [
              {
                name: "beforeFrequency",
                field: "beforeFrequency",
                // 빈도
                label: "LBL0001009",
                align: "center",
                style: "width:50px",
                sortable: false,
              },
              {
                name: "beforeStrength",
                field: "beforeStrength",
                // 강도
                label: "LBL0001010",
                align: "center",
                style: "width:50px",
                sortable: false,
              },
              {
                name: "beforeRisk",
                field: "beforeRisk",
                // 위험도
                label: "LBL0001011",
                align: "center",
                style: "width:70px",
                sortable: false,
                type: "proxy",
                component: this.riskPopComponent,
              },
            ],
          },
          {
            name: "picture",
            field: "picture",
            // 개선<br/>전/후<br/>사진
            label: "개선 전/후 사진",
            align: "center",
            type: "custom",
            style: "width:70px",
            sortable: false,
          },
          {
            name: "improvementMeasures",
            field: "improvementMeasures",
            // 추가 리스크관리 계획
            label: "LBL0001122",
            align: "left",
            style: "width:150px",
            type: "text",
            sortable: false,
          },
          {
            name: "improveFlag",
            field: "improveFlag",
            // 개선<br/>진행<br/>여부
            label: "개선진행여부",
            align: "center",
            style: "width:100px",
            sortable: false,
            setHeader: true,
            type: "select",
            comboItems: this.improveFlagItems,
          },
          {
            name: "impr",
            field: "impr",
            // 개선진행
            label: "LBL0001178",
            align: "center",
            child: [
              {
                name: "customCol",
                field: "customCol",
                label: "LBLIMPRNO_PROGRESS",
                align: "center",
                style: "width:150px",
                type: "custom",
                sortable: false,
              },
            ],
          },
          {
            name: "after",
            field: "after",
            // 개선후
            label: "LBL0001012",
            align: "center",
            child: [
              {
                name: "afterFrequency",
                field: "afterFrequency",
                // 빈도
                label: "LBL0001009",
                align: "center",
                style: "width:50px",
                sortable: false,
              },
              {
                name: "afterStrength",
                field: "afterStrength",
                // 강도
                label: "LBL0001010",
                align: "center",
                style: "width:50px",
                sortable: false,
              },
              {
                name: "afterRisk",
                field: "afterRisk",
                // 위험도
                label: "LBL0001011",
                align: "center",
                style: "width:70px",
                sortable: false,
                required: true,
                type: "proxy",
                component: this.riskPopComponent,
              },
            ],
          },
          {
            name: "assessDate",
            field: "assessDate",
            // 평가일
            label: "LBL0001013",
            align: "center",
            type: "date",
            setHeader: true,
            style: "width:130px",
            sortable: false,
          },
          {
            name: "assessUserName",
            field: "assessUserName",
            // 평가자
            label: "LBL0001014",
            align: "center",
            type: "user",
            setHeader: true,
            userId: "assessUserId",
            jobFlag: true,
            style: "width:120px",
            sortable: false,
          },
          {
            name: "riskbookFlag",
            field: "riskbookFlag",
            // 위험등록부
            label: "LBL0001171",
            align: "center",
            sortable: true,
            type: "check",
            true: "Y",
            false: "N",
          },
        ];
      } else {
        cols = [
          {
            name: "item",
            field: "item",
            // 평가내용
            label: "LBL0001179",
            align: "left",
            sortable: false,
            type: "custom",
          },
        ];
      }
      return cols;
    },
    selectScenario() {
      return Boolean(this.scenario.ramKrasAssessScenarioId);
    },
    scenarioTarget() {
      return this.selectScenario
        ? `${this.scenario.jobName} - ${this.scenario.riskHazardNameClass}`
        : "";
    },
    afterRiskEditable() {
      return this.scenario.improveFlag !== "N";
    },
    requestContentsCols() {
      return ["riskHazardNameClass", "riskOccurrenceCause"];
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.ram.kras.scenario.list.url;
      this.detailUrl = selectConfig.ram.kras.scenario.get.url;
      this.listImprUrl = selectConfig.ram.kras.riskReduce.impr.url;
      this.saveUrl = transactionConfig.ram.kras.scenario.save.url;
      this.saveUnitUrl = transactionConfig.ram.kras.scenario.saveUnit.url;
      this.deleteUrl = transactionConfig.ram.kras.scenario.delete.url;
      this.completeUrl = transactionConfig.ram.assessProcess.complete.url;
      // code setting
      // list setting
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = {
        ramRiskAssessmentPlanId: this.process.ramRiskAssessmentPlanId,
        processCd: this.process.processCd,
      };
      this.$http.request((_result) => {
        this.process.scenarios = _result.data;
      });
    },
    getDetail(ramKrasAssessScenarioId) {
      this.$http.url = this.$format(this.detailUrl, ramKrasAssessScenarioId);
      this.$http.type = "GET";
      this.$http.request((_result) => {
        this.$_.extend(this.scenario, _result.data);

        this.$set(
          this.attachHazardInfo,
          "taskKey",
          this.scenario.ramRiskHazardId,
        );
        // this.$set(this.attachBeforeInfo, 'taskKey', this.scenario.ramKrasAssessScenarioId)
        // this.$set(this.attachAfterInfo, 'taskKey', this.scenario.ramKrasAssessScenarioId)
        this.$set(
          this.attachBeforeInfo,
          "task",
          this.$_.map(this.scenario.imprs, (impr) => {
            return {
              taskClassCd: "IBM_BEFORE",
              taskKey: impr.sopImprovementId,
            };
          }),
        );
        this.$set(
          this.attachAfterInfo,
          "task",
          this.$_.map(this.scenario.imprs, (impr) => {
            return {
              taskClassCd: "IBM_AFTER",
              taskKey: impr.sopImprovementId,
            };
          }),
        );
      });
    },
    getImprs() {
      this.$http.url = this.listImprUrl;
      this.$http.type = "GET";
      this.$http.param = {
        ramKrasAssessScenarioId: this.scenario.ramKrasAssessScenarioId,
      };
      this.$http.request((_result) => {
        this.$set(this.scenario, "imprs", _result.data);
      });
    },
    research() {
      this.$emit("research", "scenario");
    },
    /* eslint-disable no-unused-vars */
    imprChange(data) {
      this.$refs["table"].$refs["compo-table"].resetVirtualScroll();
      this.research();
    },
    innerBtnClicked(col, props, btn) {
      if (col.name === "riskHazardNameClass") {
        if (btn.value === "1") {
          this.rowIndex = props.rowIndex;
          this.popupOptions.title = "LBL0001180"; // 유해위험요인별 원인/결과
          this.popupOptions.param = {
            type: "multiple",
            searchType: "6", //1: 작업조회, 2:작업단계, 3:작업단계별 유해위험요인, 4:작업단계별 유해위험요인별 원인/결과
            subProcessCd: this.process.processCd,
            mdmHazardFactorsId: props.row.ramRiskHazardId,
          };
          this.popupOptions.target = () =>
            import(`${"@/pages/common/process/sopPop.vue"}`);
          this.popupOptions.width = "70%";
          this.popupOptions.visible = true;
          this.popupOptions.closeCallback = this.closeCausePopup;
        } else {
          this.process.scenarios.splice(props.rowIndex, 0, {
            ramKrasAssessScenarioId: uid(), // 시나리오 일련번호_시나리오의 한 라인(원일별)
            ramRiskAssessmentPlanId: this.process.ramRiskAssessmentPlanId, // 평가 일련번호
            processCd: this.process.processCd, // 단위공정 코드
            processName: this.process.processName, // 단위공정 코드
            groupMdmSopId: props.row.groupMdmSopId, // 유해위험분류 코드
            mdmSopId: props.row.mdmSopId, // 유해위험분류 코드
            jobName: props.row.jobName, // 유해위험분류 코드
            ramRiskHazardClassCd: props.row.ramRiskHazardClassCd, // 유해위험분류 코드
            ramRiskHazardId: props.row.ramRiskHazardId, // 유해위험요인 코드
            riskHazardName: props.row.riskHazardName, // 유해위험요인 명
            riskHazardNameClass: props.row.riskHazardNameClass, // 유해위험요인 명
            riskOccurrenceCause: "", // 위험발생 원인
            riskOccurrenceResult: "", // 위험발생 결과
            relationLaw: "", // 관련법규_유해위험요인 마스터에스 불러와서 편집후 저장
            currentSafetyMeasures: "", // 현재 안전조치
            beforeRamMatrixRiskId: "", // 전 위험도 no
            afterRamMatrixRiskId: "", // 후 위험도 no
            improvementMeasures: "", // 개선대책
            assessDate: this.$comm.getToday(), // 평가일
            assessUserName: this.$_.clone(this.process.assessUserName),
            assessUserId: this.$_.clone(this.process.assessUserId),
            sopImprovementIds: "",
            ibmStepNames: "",
            riskbookFlag: "N",
            editFlag: "C",
            ramMatrixId: this.process.ramMatrixId,
            // 위험등록부 등재를 위한 prop
            riskRegisterFlag: false,
          });
        }
      }
    },
    closeCausePopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;

      if (data && data.length > 0) {
        this.$_.forEach(data, (item) => {
          this.process.scenarios.splice(this.rowIndex, 0, {
            ramKrasAssessScenarioId: uid(), // 시나리오 일련번호_시나리오의 한 라인(원일별)
            ramRiskAssessmentPlanId: this.process.ramRiskAssessmentPlanId, // 평가 일련번호
            processCd: this.process.processCd, // 단위공정 코드
            processName: this.process.processName, // 단위공정 코드
            groupMdmSopId: `${this.process.processCd}/${item.jobStepName}`, // 유해위험분류 코드
            groupRiskHazard: `${this.process.processCd}/${item.jobStepName}/${item.riskHazardName}`, // 유해위험분류 코드
            mdmSopId: item.mdmSopId, // 유해위험분류 코드
            jobName: item.jobStepName, // 유해위험분류 코드
            ramRiskHazardClassCd: item.ramRiskHazardClassCd, // 유해위험분류 코드
            ramRiskHazardId: item.mdmHazardFactorsId, // 유해위험요인 코드
            riskHazardName: item.riskHazardName, // 유해위험요인 명
            riskHazardNameClass: item.riskHazardNameClass, // 유해위험요인 명
            riskOccurrenceCause: item.hazardOccurReason, // 위험발생 원인
            riskOccurrenceResult: item.hazardOccurResult, // 위험발생 결과
            relationLaw: item.relevantLegalStandards, // 관련법규_유해위험요인 마스터에스 불러와서 편집후 저장
            currentSafetyMeasures: "", // 현재 안전조치
            beforeRamMatrixRiskId: "", // 전 위험도 no
            afterRamMatrixRiskId: "", // 후 위험도 no
            improvementMeasures: "", // 개선대책
            assessDate: this.$comm.getToday(), // 평가일
            assessUserName: this.$_.clone(this.process.assessUserName),
            assessUserId: this.$_.clone(this.process.assessUserId),
            sopImprovementIds: "",
            ibmStepNames: "",
            riskbookFlag: "N",
            editFlag: "C",
            ramMatrixId: this.process.ramMatrixId,
            // 위험등록부 등재를 위한 prop
            riskRegisterFlag: false,
          });
        });
      }
    },
    openImprRequest() {
      let requestContents = this.scenario.riskHazardNameClass;
      if (this.scenario.riskOccurrenceCause) {
        requestContents += " / " + this.scenario.riskOccurrenceCause;
      }

      this.popupOptions.title = "LBLIMPRREQUEST";
      this.popupOptions.param = {
        requestContents: requestContents,
        relationTableKey: this.scenario.ramKrasAssessScenarioId,
        ibmTaskTypeCd: "ITT0000020",
        ibmTaskUnderTypeCd: "ITTU000025",
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/sop/ibm/imprDetail.vue"}`);
      this.popupOptions.width = "80%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeCardImprPopup;
    },
    closeCardImprPopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;

      this.getImprs();
    },
    linkClick(data, row) {
      this.popupOptions.title = "LBLIMPROVE";
      this.popupOptions.param = {
        sopImprovementId: data.sopImprovementId,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/sop/ibm/imprDetail.vue"}`);
      this.popupOptions.width = "80%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeCardImprPopup;
    },
    /* eslint-disable no-unused-vars */
    callbackProxy(data, props, col) {
      let isAfterRisk9 = false;
      if (col.name === "beforeRisk") {
        this.$set(
          this.process.scenarios[props.rowIndex],
          "beforeFrequency",
          data.f,
        );
        this.$set(
          this.process.scenarios[props.rowIndex],
          "beforeStrength",
          data.s,
        );
        this.$set(this.process.scenarios[props.rowIndex], "beforeRisk", data.r);
        this.$set(
          this.process.scenarios[props.rowIndex],
          "beforeRamMatrixRiskId",
          data.ramMatrixRiskId,
        );

        // if (this.process.scenarios[props.rowIndex].improveFlag === "N") {
        this.$set(
          this.process.scenarios[props.rowIndex],
          "afterFrequency",
          data.f,
        );
        this.$set(
          this.process.scenarios[props.rowIndex],
          "afterStrength",
          data.s,
        );
        this.$set(this.process.scenarios[props.rowIndex], "afterRisk", data.r);
        this.$set(
          this.process.scenarios[props.rowIndex],
          "afterRamMatrixRiskId",
          data.ramMatrixRiskId,
        );

        isAfterRisk9 = data.r && Number(data.r) >= 8 ? true : false;
        // }
      } else {
        this.$set(
          this.process.scenarios[props.rowIndex],
          "afterFrequency",
          data.f,
        );
        this.$set(
          this.process.scenarios[props.rowIndex],
          "afterStrength",
          data.s,
        );
        this.$set(this.process.scenarios[props.rowIndex], "afterRisk", data.r);
        this.$set(
          this.process.scenarios[props.rowIndex],
          "afterRamMatrixRiskId",
          data.ramMatrixRiskId,
        );

        isAfterRisk9 = data.r && Number(data.r) >= 8 ? true : false;
      }

      if (isAfterRisk9) {
        // 개선 후 위험도가 9 이상인 경우 위험등록부 자동등재
        this.$set(this.process.scenarios[props.rowIndex], "riskbookFlag", "Y");
      } else {
        this.$set(this.process.scenarios[props.rowIndex], "riskbookFlag", "N");
      }

      if (this.process.scenarios[props.rowIndex].editFlag !== "C") {
        this.$set(this.process.scenarios[props.rowIndex], "editFlag", "U");
      }
    },
    callbackCardProxy(data, color, refName) {
      let isAfterRisk9 = false;
      if (refName === "beforeRiskProxy") {
        // 개선 전
        this.$set(this.scenario, "beforeFrequency", data.f);
        this.$set(this.scenario, "beforeStrength", data.s);
        this.$set(this.scenario, "beforeRisk", data.r);
        this.$set(this.scenario, "beforeRamMatrixRiskId", data.ramMatrixRiskId);

        // if (this.scenario.improveFlag === "N") {
        this.$set(this.scenario, "afterFrequency", data.f);
        this.$set(this.scenario, "afterStrength", data.s);
        this.$set(this.scenario, "afterRisk", data.r);
        this.$set(this.scenario, "afterRamMatrixRiskId", data.ramMatrixRiskId);
        isAfterRisk9 = data.r && Number(data.r) >= 8 ? true : false;
        // }
      } else {
        // 개선 후
        this.$set(this.scenario, "afterFrequency", data.f);
        this.$set(this.scenario, "afterStrength", data.s);
        this.$set(this.scenario, "afterRisk", data.r);
        this.$set(this.scenario, "afterRamMatrixRiskId", data.ramMatrixRiskId);
        isAfterRisk9 = data.r && Number(data.r) >= 8 ? true : false;
      }
      if (isAfterRisk9) {
        // 개선 후 위험도가 9 이상인 경우 위험등록부 자동등재
        this.$set(this.scenario, "riskbookFlag", "Y");
      } else {
        this.$set(this.scenario, "riskbookFlag", "N");
      }
      this.$refs[refName].hide();
      this.$forceUpdate();
    },
    tableDataChange(props, col) {
      if (col.name === "improveFlag") {
        // 개선을 진행 할 건지 여부 체크
        if (props.row[col.name] === "N") {
          this.$set(props.row, "improvementMeasures", "현상 유지");
          this.$set(props.row, "afterFrequency", props.row.beforeFrequency);
          this.$set(props.row, "afterStrength", props.row.beforeStrength);
          this.$set(props.row, "afterRisk", props.row.beforeRisk);
          this.$set(
            props.row,
            "afterRamMatrixRiskId",
            props.row.beforeRamMatrixRiskId,
          );
        }
      }
    },
    listView() {
      this.scenarioViewGroup = "L";
    },
    cardView() {
      this.scenarioViewGroup = "C";
    },
    improveFlagChange() {
      if (this.scenario.improveFlag === "N") {
        // 유지하는 경우 개선 전 위험도를 복사 및 계획에는 현상유지 setting
        this.$set(this.scenario, "improvementMeasures", "현상 유지");
        this.$set(
          this.scenario,
          "afterFrequency",
          this.scenario.beforeFrequency,
        );
        this.$set(this.scenario, "afterStrength", this.scenario.beforeStrength);
        this.$set(this.scenario, "afterRisk", this.scenario.beforeRisk);
        this.$set(
          this.scenario,
          "afterRamMatrixRiskId",
          this.scenario.beforeRamMatrixRiskId,
        );
      }
    },
    saveScenario() {
      //if (this.$comm.validTable(this.gridColumns, this.process.scenarios)) {
      window.getApp.$emit("CONFIRM", {
        title: "LBLCONFIRM",
        message: "MSGSAVE", // 저장하시겠습니까?
        // TODO : 필요시 추가하세요.
        type: "info", // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$_.forEach(this.process.scenarios, (item) => {
            item.regUserId = this.$store.getters.user.userId;
            item.chgUserId = this.$store.getters.user.userId;
          });

          this.isSave = !this.isSave;
        },
        // 취소 callback 함수
        cancelCallback: () => {},
      });
      //}
    },
    saveScenarioCallback() {
      window.getApp.$emit("APP_REQUEST_SUCCESS");
      this.research();
      this.getList();
    },
    saveScenarioUnit() {
      this.$refs["editForm"].validate().then((_result) => {
        if (_result) {
          window.getApp.$emit("CONFIRM", {
            title: "LBLCONFIRM",
            message: "MSGSAVE", // 저장하시겠습니까?
            // TODO : 필요시 추가하세요.
            type: "info", // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.scenario.chgUserId = this.$store.getters.user.userId;

              this.isSaveUnit = !this.isSaveUnit;
            },
            // 취소 callback 함수
            cancelCallback: () => {},
          });
        } else {
          window.getApp.$emit("APP_VALID_ERROR");
        }
      });
    },
    saveScenarioUnitCallback() {
      window.getApp.$emit("APP_REQUEST_SUCCESS");
      this.research();
      this.getList();
    },
    removeScenario() {
      let selectData = this.$refs["table"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "LBLGUIDE", // 안내
          message: "MSGNOITEMS", // 선택된 항목이 없습니다.
          type: "warning", // success / info / warning / error
        });
      } else {
        window.getApp.$emit("CONFIRM", {
          title: "LBLCONFIRM",
          message: "MSGREMOVE", // 삭제하시겠습니까?,
          // TODO : 필요시 추가하세요.
          type: "info", // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.deleteUrl;
            this.$http.type = "DELETE";
            this.$http.param = {
              data: Object.values(selectData),
            };
            this.$http.request(() => {
              window.getApp.$emit("APP_REQUEST_SUCCESS");
              this.$_.forEach(selectData, (item) => {
                this.process.scenarios.splice(
                  this.$_.findIndex(this.process.scenarios, item),
                  1,
                );
              });
              this.$refs["table"].$refs["compo-table"].clearSelection();

              this.planUpdateBtnData.planResearch = uid();
            });
          },
          // 취소 callback 함수
          cancelCallback: () => {},
        });
      }
    },
    completeProcess() {
      // 도면 별 노드에 시나리오가 하나 이상 등록되었는지?
      // 화면에서 추가는 하고 저장을 하지 않았을 시에 해당 데이터도 일괄 저장 처리
      // 저장 처리 후 callback에서 process 목록 재조회
      let isProgress = true;
      if (!this.process.scenarios || this.process.scenarios.length === 0) {
        isProgress = false;
        window.getApp.$emit("ALERT", {
          title: "LBLGUIDE", // 안내
          // 공정 [' + this.process.processName + ']에 등록된 시나리오가 없습니다.
          message: this.getLangMessage("MSG0000399", {
            s1: this.process.processName,
          }),
          type: "warning", // success / info / warning / error
        });
      }

      if (
        isProgress &&
        this.$comm.validTable(this.gridColumns, this.process.scenarios)
      ) {
        window.getApp.$emit("CONFIRM", {
          title: "LBLCONFIRM",
          message: "MSGCOMPLETE", // 완료하시겠습니까?,
          // TODO : 필요시 추가하세요.
          type: "info", // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.process.chgUserId = this.$store.getters.user.userId;
            this.process.ramProcessAssessStepCd = "RPA0000005";

            this.isComplete = !this.isComplete;
          },
          // 취소 callback 함수
          cancelCallback: () => {},
        });
      }
    },
    completeProcessCallback(_result) {
      window.getApp.$emit("APP_REQUEST_SUCCESS");
      this.$emit("assessComplete", _result.data);

      this.planUpdateBtnData.planResearch = uid();
    },
    openHazardPicture(props) {
      this.popupOptions.title = "LBL0001110"; // 유해위험요인 사진
      this.popupOptions.param = {
        ramRiskHazardId: props.row.ramRiskHazardId,
        disabled: this.disabled,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/common/hazard/riskHazardPicture.vue"}`);
      this.popupOptions.width = "30%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeHazardPicturePopup;
    },
    closeHazardPicturePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
    openImprPicture(props) {
      this.popupOptions.title = "LBL0001181"; // 개선 사진
      this.popupOptions.param = {
        ramKrasAssessScenarioId: props.row.ramKrasAssessScenarioId,
        sopImprovementIds: props.row.sopImprovementIds,
        disabled: this.disabled,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/ram/kras/action/krasScenarioImprPicture.vue"}`);
      this.popupOptions.width = "60%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeScenarioImprPicturePopup;
    },
    closeScenarioImprPicturePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
    compareScenario() {
      let uri = `/ram/compare/compareScenario?ramTechniqueCd=${this.param.ramTechniqueCd}&ramRiskAssessmentPlanId=${this.param.ramRiskAssessmentPlanId}&processCd=${this.process.processCd}`;
      this.$refs.winPopup.openWinPop(uri, 1560, 700);
    },
    evtCloseWinPopup() {
      Object.assign(
        this.$data.activeWinProps,
        this.$options.data().activeWinProps,
      );
    },
    onRecvWinPop(recvObj) {
      if (recvObj) {
        this.$set(this.activeWinProps, "processCd", recvObj.processCd);
        this.$set(
          this.activeWinProps,
          "ramKrasAssessScenarioId",
          recvObj.ramKrasAssessScenarioId,
        );
      }
    },
    setTrClass(props) {
      return props.row.processCd === this.activeWinProps.processCd &&
        props.row.compareId === this.activeWinProps.ramKrasAssessScenarioId
        ? "bg-purple-2"
        : "";
    },
    /**
     * 재조회
     * 목적 : 돌아가기전 데이터를 저장 했을 수도 있지만
     *        입력만 하고 돌아가는 경우를 대비하기 위함
     */
    back() {
      this.getList();
    },
  },
};
</script>
<style lang="sass">
.scenario-chip i
  margin-right: -0.2em !important

.scenario-view-group
  button
    margin: 0 !important

.scenario-card-title
  margin-left: -5px
  font-size: 0.8rem

.scenario-card-side
  text-align: center
  align-self: center
  // flex-basis: 50%

.card-risk-item
  padding-top: 0px
  padding-bottom: 0px
  min-height: auto
.card-risk-info
  width: auto
  min-width: 0
  max-width: 100%
  flex: 10000 1 0%
  display: flex
  border-radius: 10px
  font-size: 1rem
  height: 30px
.before-risk
  background: #3A98B9
  margin-right: 5px
.after-risk
  background: #3A98B9
  margin-left: 5px
.risk-number
  font-size: 1.3rem

.detail-risk
  font-size: 0.9rem
  font-weight: 600
.detail-risk-num
  font-size: 1rem
  font-weight: 700
  color: #e63946

.card-scenario-list
  padding: 0px 16px !important
  min-height: 28px
</style>
